import React, { useEffect, useState } from "react";
import ButtonAdminpanel from "../ButtonAdminpanel";
import DropDown from "../DropDown";
import { getCountryList } from "../../actions/defaultDataAction";
import { connect } from "react-redux";
import { default as ReactSelect, components } from "react-select";
import { map } from "lodash";
import Emitter from "../../utils/Emitter";
import defaultValues from "../../constant/defaultValues";

const LeadFilter = (props) => {

    const { admin, TRADE_MODE } = defaultValues;

    const findByOptions = [{
        label: "All", value: -1,
    }, {
        label: "Pending", value: 0,
    }, {
        label: "InProgress", value: 2,
    }, {
        label: "Active", value: 1,
    }, {
        label: "Sent For Approval", value: 3,
    }, {
        label: "Rejected", value: 4,
    }, {
        label: "Suspended", value: 10,
    }];

    const [findByOptionVal, setFindByOptionVal] = useState(findByOptions[0]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [countryList, setCounrtyList] = useState([]);

    const [tradeModeList, setTradeModeList] = useState(TRADE_MODE);
    const [selectedTradeMode, setSelectedTradeMode] = useState(null);

    const handleFindByChange = (val) => {
        setFindByOptionVal(val);
    }

    const handleCountryChange = (val) => {
        setSelectedCountry(val);
    }

    const handleTradeModeChange = (val) => {
        setSelectedTradeMode(val)
    }

    const filterLeads = () => {
        let filterObj = {
            status_val: findByOptionVal.value,
            country: map(selectedCountry, 'value'),
            trade_mode: map(selectedTradeMode, 'value'),
        }
        filterObj.limit = admin.LIMIT;
        filterObj.offset = admin.OFFSET;
        filterObj.current_page = 1;
        // props.onFilterChange(filterObj);

        Emitter.emit("SET_FILTER_LEADS", filterObj);
        // Emitter.emit("FILTER_MEMBERS", filterObj);

        setTimeout(() => {
            Emitter.emit("FILTER_LEADS", filterObj);
        }, 1000);

    }

    const resetFilter = () => {
        setFindByOptionVal(findByOptions[0]);
        setSelectedCountry([]);
        setSelectedTradeMode([]);
        let filterObj = {
            status_val: -1,
            country: [],
            trade_mode: []
        }
        filterObj.table_search = "";
        filterObj.sortDirection = "DESC";
        filterObj.columnName = "created_at";
        filterObj.limit = admin.LIMIT;
        filterObj.offset = admin.OFFSET;
        // props.onFilterChange(filterObj);

        Emitter.emit("SET_FILTER_LEADS", filterObj);

        setTimeout(() => {
            Emitter.emit("FILTER_LEADS", filterObj);
        }, 1000);
    }

    const CustomOption = ({ innerRef, innerProps, isSelected, label }) => (

        <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }} className={isSelected ? "div-item-selected" : "div-item-unselected"} >
            {/* <input type="checkbox" checked={isSelected} readOnly /> */}
            {isSelected && <div className={` item-selected `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}
            {!isSelected && <div className={` item-selected2 `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}

        </div>

    );

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            '&:hover': {
            },
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#4c9bdb', // Background of the selected multi-value items
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#fff', // Color of the text inside the multi-value
            fontSize: "20px"
        }),

        multiValueRemove: (provided) => ({
            ...provided,
            color: '#df0024', // Remove button color
            ':hover': {
                backgroundColor: '#df0024', // Background color on hover for the remove button
            },
        }),
    };

    const MoreSelectedBadge = ({ items }) => {
        const style = {
            marginLeft: "auto",
            background: "#d4eefa",
            borderRadius: "4px",
            fontFamily: "Open Sans",
            fontSize: "11px",
            padding: "3px",
            order: 99,
        };

        const title = items.join(", ");
        const length = items.length;
        const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

        return (
            <div style={style} title={title}>
                {label}
            </div>
        );
    };

    const MultiValue = ({ index, getValue, ...props }) => {
        const maxToShow = 2;
        const overflow = getValue()
            .slice(maxToShow)
            .map((x) => x.label);

        return index < maxToShow ? (
            <components.MultiValue {...props} />
        ) : index === maxToShow ? (
            <MoreSelectedBadge items={overflow} />
        ) : null;
    };



    useEffect(() => {

        const fetchData = async () => {
            await props.getCountryList().then((response) => {
                if (response) {
                    let cList = map(response, (val) => {
                        return {
                            label: val.name,
                            value: val.id
                        }
                    });
                    setCounrtyList(cList);
                }
            }).catch((err) => {
                console.log("error === ", err);
            })
        }

        fetchData();

    }, []);


    return (<div className="bg-white shadow rounded p-4 mb-4">
        <div className="row ">
            <div className="col-md-6 col-xxl-3 col-lg-6 my-1">
                <ReactSelect
                    options={countryList}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option: CustomOption, IndicatorSeparator: () => null, MultiValue }}
                    onChange={handleCountryChange}
                    value={selectedCountry}
                    // onInputChange={handleHsCodeInputChange}
                    removeSelected={false}
                    // isDisabled={isSuperAdmin ? false : (props.isDisable || props.disableProfile)}
                    styles={customStyles}
                    placeholder="Select country"
                    className="member-filter-container"
                    classNamePrefix="member-filter-select"
                    noOptionsMessage={() => "No Country Found"}
                    id="target_country_dropdown"
                // isOptionDisabled={() => hs_code.length >= 3}
                />
            </div>
            <div className="col-md-6 col-xxl-3 col-lg-6 my-1">
                <ReactSelect
                    options={tradeModeList}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option: CustomOption, IndicatorSeparator: () => null, MultiValue }}
                    onChange={handleTradeModeChange}
                    value={selectedTradeMode}
                    removeSelected={false}
                    styles={customStyles}
                    placeholder="Select Trade Mode"
                    className="member-filter-container"
                    classNamePrefix="member-filter-select"
                    noOptionsMessage={() => "No Trade Mode Found"}
                    id="trade_mode_dropdown"
                />
            </div>
            <div className="col-md-6 col-xxl-2 col-lg-6 my-1">
                <DropDown
                    placeholder="Select.."
                    options={findByOptions}
                    value={findByOptionVal}
                    onChange={handleFindByChange}
                    menuPlacement={'bottom'}
                />
            </div>
            <div className="filter-search-btn col-xl-4 col-md-6 d-flex align-items-center mt-2">
                <div className="d-flex align-items-center">
                    <ButtonAdminpanel
                        type="button"
                        onClick={filterLeads}
                        className="btn-regi"
                    >
                        {" "}
                        <i className="fa-solid fa-magnifying-glass text-white"></i> Search{" "}
                    </ButtonAdminpanel>
                    <button type="button" className=" btn filter-reset-btn mx-2" onClick={resetFilter}>
                        <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fillRule="evenodd" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>
                        Reset</button>
                </div>
            </div>
        </div>
    </div>)
}

const mapStateToProps = (state) => {
    return {

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCountryList: () => dispatch(getCountryList()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(LeadFilter));